import Header from 'layout/Header';
import Paper from 'components/Paper';
import styles from './Settings.module.css';
import messages from './Settings.messages';
import ChangePassword from './ChangePassword';

export default function Settings() {
  return (
    <>
      <Header title={messages.headerTitle} />
      <Paper className={styles.settings}>
        <ChangePassword />
      </Paper>
    </>
  );
}
